class cu {
    static  gk(s) {
        const date = new Date();
        const a = 'B';
        const x = 'y';
        const h = 'U';
        const t = date.getTime();
        const n = 'c';
        const i = 'g';
        const o = 'G';
        const ts = date.toISOString();
        const r = 'p';
        const l = btoa(ts);
        return {k: `V${a}JI${o}NvZ${o}${h}${s}0a${o}${h}${i}Q${l}d${o}h${r}${n}${x}${a}${r}${n}${x}${a}`, t};
    }
}

export default cu;